import styled from 'styled-components';
import Colors from '../../config/Colors';

export const ErrorText = styled.p`
    font-family: NunitoSans-Regular;
    font-size: 1.4rem;
    color: ${Colors.danger};
`;
